import { signIn as nextSignIn, signOut as nextSignOut } from 'next-auth/react';

import { getAppConfig } from '@services/config';

import { homeRoute } from '@helpers/routes';

import { auth } from '@constants/auth';

const providerName = 'oauth2';

const appConfig = getAppConfig();

export async function signIn(callbackUrl?: string) {
    return nextSignIn(providerName, { callbackUrl });
}

export async function signOut() {
    return nextSignOut({ callbackUrl: homeRoute.path });
}

export function signInWithTgtId(tgtId: string, callbackUrl?: string) {
    window.location.href = `${appConfig.oauth2.tgtUrl}?tgtId=${tgtId}&service=${encodeURI(appConfig.oauth2.tgtCallbackUrl + '?callbackUrl=' + callbackUrl)}`;
}

export async function getServerSession() {
    return auth();
}
